export const clearItem =(name)=> localStorage.removeItem(name)
export const getItem =(name)=> localStorage.getItem(name)
export const setItem =(name ,value)=> localStorage.setItem(name ,value)